import { useEffect } from 'react';
import { createPortal } from 'react-dom';

import { Button } from '../buttons';
import { Container, Content, ContentInner, Overlay, Title, Buttons, CloseButton } from './dialog.styled';
import { useDialog } from './hooks/use-dialog';
// let lastZIndex = 999;

export const Dialog = (props) => {
  const {
    align = '',
    size = 'lg',
    closeOnOverlayClick = false,
    closeOnEscape = false,
    useOverlay = true,
    hideOverlay = false,
    noPortal = false,
    useCloseBtn,
    title,
    children,
    buttons,
    w,
    close,
    className,
    ...rest
  } = props;

  const pad = size === 'sm' ? 15 : 20;

  const doCloseOverlay = (event) => {
    event.preventDefault();
    event.stopPropagation();
    if (closeOnOverlayClick) {
      doClose();
    }
  };

  const doClose = () => {
    // console.log('doclose');
    if (props.close) {
      close();
    }
  };

  useEffect(() => {
    const handleKeyPress = (e) => {
      // console.log(e.which);
      switch (e.which) {
        // escape
        case 27:
          {
            if (closeOnEscape) {
              doClose();
            }
          }
          break;
      }
    };
    window.addEventListener('keydown', handleKeyPress);
    return () => {
      window.removeEventListener('keydown', handleKeyPress);
    };
  }, []);

  /**
   * get buttons el
   * @returns
   */
  const getButtonsEl = () => {
    if (!buttons) {
      return null;
    }
    return buttons.map((el, idx) => {
      const { working, title, img, ...elrest } = el;
      if (working) {
        elrest.className = 'loading';
      }
      return (
        <Button key={idx} {...elrest}>
          {img && <img width="10" src={img} alt="" />}
          {title}
        </Button>
      );
    });
  };

  /**
   * disable click
   * @param {*} event
   */
  const disableClick = (event) => {
    event.stopPropagation();
  };

  // buttons
  const buttonsEl = getButtonsEl();
  const cmp = (
    <Container className={className} {...rest} onClick={disableClick}>
      {useOverlay && <Overlay onClick={doCloseOverlay} $hidden={hideOverlay} />}
      <Content $w={w} className={className}>
        {title && <Title $pad={pad}>{title}</Title>}
        {useCloseBtn && <CloseButton onClick={doClose}></CloseButton>}
        <ContentInner $pad={pad}>{children}</ContentInner>
        {buttons && (
          <Buttons $align={align} $pad={pad}>
            {buttonsEl}
          </Buttons>
        )}
      </Content>
    </Container>
  );

  return noPortal ? cmp : createPortal(cmp, document.body);
};

export { useDialog };
